<template>
  <page132 />
</template>

<script>

import Page132 from "@/views/boards/single-page/132/Page.vue";

export default {
  components: {Page132},
  props: {
    isPrint: Boolean,
    board: Object,
    value: Object
  },
}
</script>

<style scoped>

</style>
